<template>
  <div class="offset-gallery has-accent-left" :class="accentColor">
    <div class="container">
      <div v-if="singleCol" class="columns">
        <div class="column is-full">
        <slot></slot>
        </div>
      </div>
      <div class="columns" v-else>
        <div class="column is-half">
          <slot name="col1"></slot>
        </div>
        <div class="column is-half is-offset">
          <slot name="col2"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: [ 'accentColor', 'singleCol' ]
  }
</script>

<style lang="scss" scoped>

  .offset-gallery {
    padding-top: 30px;
    position: relative;

  }
  .has-accent-left .container {
    position: relative;
    &::after {
      content: "";
      background-color: inherit;
      position: absolute;
      top: 120px;
      height: 80%;
      right: -50px;
      left: -100%;
    }
  }

  .has-accent-right .container {
    position: relative;
    &::after {
      content: "";
      background-color: #D3D4DB;
      position: absolute;
      top: 120px;
      height: 80%;
      left: -50px;
      right: -100%;
    }
  }
  .has-accent-center .container {
    position: relative;
    &::after {
      content: "";
      background-color: #D3D4DB;
      position: absolute;
      top: 120px;
      height: 80%;
      left: -50px;
      right: -50px;
    }
  }
  .has-accent-light-slate .container::after {background-color: #D3D4DB;}
  .has-accent-slate .container::after {background-color: #616C78;}

  .has-accent-light-green .container::after {background-color: #D5DBDB;}
  .has-accent-green .container::after {background-color: #809696;}

  .has-accent-light-tan .container::after {background-color: #DBDAD9;}
  .has-accent-tan .container::after {background-color: #ADA8A1;}

  .fixed-bottom .container::after {
    bottom: 0;
    top: auto;
  }

  .columns {
    position: relative;
    z-index: 1;
  }
  .column.is-offset {
    margin-top: 160px;
  }
</style>